<template>
  <v-btn
    color="primary"
    outlined
    class="text-uppercase border-bold gray-550"
    download
    target="_blank"
    :href="module.ebook.file.url"
    @click="accessed_ebook(module.ebook.id)"
  >
    <img
      src="/images/download_icon_blue.svg"
      width="18px"
    >
    <span class="ml-2 text-gray-550">
      Baixe o e-book
    </span>
  </v-btn>
</template>
<script>
import {accessed_ebook} from "@/student/api/Ebook";
import { mapGetters } from "vuex";
export default {
  computed:{
    ...mapGetters(['module']),
  },
  methods: {
    accessed_ebook,
  }
}
</script>
